(function() {
'use strict';

angular
    .module('TR')
    .service('hotelRoomService', hotelRoomService);

function hotelRoomService(imageService) {
    const imageDomain = TRPCONFIG.Domain.HotelImageCDN
        ? `https://${TRPCONFIG.Domain.HotelImageCDN}`
        : imageService.getImageDomain();

    const reAbsUrl = /https?:\/\//i;

    const service = {
        restructureData,
        getImageUrl
    };

    function restructureData(hotel) {
        const roomsData = _getRoomsData(hotel);

        if (TRPCONFIG.Domain.LowestBoardTypePriceOnly === true) {
            return _lowestBoardTypePricesOnly(roomsData);
        }

        return roomsData;
    }


    function _lowestBoardTypePricesOnly(data) {
        return data.map(data => {
            data.Availability = data.Availability.map(room => {
                room.BoardTypes = room.BoardTypes.map(boardType => {
                    if (!_.isEmpty(boardType.Prices)) {
                        boardType.Prices = [_.minBy(boardType.Prices, price => price.Cost)];
                    }
                    return boardType;
                });
                return room;
            });
            return data;
        });
    }

    function _getRoomsData(hotel) {
        return _.map(hotel.Rooms, (r, i) => ({
                    Availability: _combineRatesForRoom(
                    r.FilteredAvailability || r.Availability,
                    _.keyBy(hotel.RoomDetails, 'MasterId')
                ),
                Title: r.Title,
                nonInfants: r.nonInfants,
                isRoomKidsFree: r.isRoomKidsFree,
                Id: `id${i}`
            }));
    }

    function getImageUrl({ ImageUrl, NewImageUrl }) {
        const url = TRPCONFIG.Domain.HotelImageCDN ? NewImageUrl : ImageUrl;
        if (url) {
            return reAbsUrl.test(url)
                ? url.replace('http:', 'https:')
                : imageDomain + url;
        }
    }

    function _combineRatesForRoom(prices, masterRooms) {
        //restructure the provided room availability prices in to a more compact set of data, grouping
        //by the room and boardType also add in extra data from the master room object if available
        const combinedRates = [];

        for (let i = 0; i < prices.length; i++) {
            const p = prices[i];

            const properties = (!p.MasterId || p.MasterId === 0) ? { Description: p.RoomDescription } : { MasterId: p.MasterId };
            let room = _.find(combinedRates, properties); //find a room by it's master id if present otherwise use the title
            if (!room) {
                const master = _getMasterData(masterRooms, p.MasterId); //get the master room data
                room = {
                    Description: p.RoomDescription,
                    MasterRoomDescription: master.MasterRoomDescription,
                    BoardTypes: [],
                    ImageUrl: master.ImageUrl,
                    ExtraDescription: master.Description,
                    MasterId: p.MasterId
                };
                combinedRates.push(room); //add it to the array too
            }

            //check if the board type already exists
            let board = _.find(room.BoardTypes, { BoardType: p.BoardType });
            if (!board) {
                board = {
                    BoardType: p.BoardType,
                    BoardDescription: p.BoardDescription,
                    Prices: []
                };
                room.BoardTypes.push(board);
            }

            //push this price into the boards price list
            board.Prices.push(p);
        }

        return combinedRates;
    }

    function _getMasterData(data, id) {
        //function so we can handle cases where the master id isn't present in our list
        const masterRoom = { Description: '', ImageUrl: '' };
        if (data && id && data[id]) {
            masterRoom.ImageUrl = getImageUrl(data[id]);
            masterRoom.Description = data[id].Description;
            masterRoom.MasterRoomDescription = data[id].Title;
        }
        return masterRoom;
    }


    return service;
}
})();
